import Vue from 'vue'
import _config from '@/config.js'
import Router from 'vue-router'
import SSOLoginPage from '@/default-page/sso-login'
import TermPage from '@/default-page/term-condition'
import PrivacyPage from '@/default-page/privacy-policy'
import RegisterPage from '@/default-page/register'
import VerifyPage from '@/default-page/verify'
import WaitingPage from '@/default-page/waiting'
import ResetPass from '@/default-page/reset-password'
// ========================================
import LandingPage from '@/landing-page/components/layout'
import LandLanding from '@/landing-page/landing'
import LandBeranda from '@/landing-page/beranda'
import LandKritikSaran from '@/landing-page/kritik-saran'
import LandOrganisasi from '@/landing-page/organisasi'
import LandAduan from '@/landing-page/aduan'
import LandAduanIsi from '@/landing-page/isi-aduan'

Vue.use(Router)

var router = new Router({
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'landing-apps',
      component: LandingPage,
      redirect: { name: 'landing-landing' },
      children: [
        {
          path: '/landing',
          name: 'landing-landing',
          meta: { preloader: true, floatIcon: true },
          component: LandLanding
        },
        {
          path: '/beranda',
          name: 'beranda-landing',
          meta: { preloader: true, floatIcon: true },
          component: LandBeranda
        },
        {
          path: '/organisasi-landing',
          name: 'organisasi-landing',
          meta: { preloader: true, floatIcon: true },
          component: LandOrganisasi
        },
        {
          path: '/kritik-saran',
          name: 'kritik-saran',
          meta: { preloader: true, floatIcon: false },
          component: LandKritikSaran
        },
        {
          path: '/pengaduan',
          name: 'pengaduan-landing',
          meta: { preloader: true, floatIcon: true },
          component: LandAduan
        },
        {
          path: '/lapor-aduan',
          name: 'pengisian-aduan',
          meta: { preloader: true, floatIcon: false },
          component: LandAduanIsi
        },
        {
          path: '/sekar-news',
          name: 'sekar-news',
          meta: { preloader: true, floatIcon: true },
          props: true,
          component: () => import('@/landing-page/detail/sekar-news.vue')
        },
        {
          path: '/sekar-gallery',
          name: 'sekar-gallery',
          meta: { preloader: true, floatIcon: true },
          props: true,
          component: () => import('@/landing-page/detail/sekar-gallery.vue')
        },
        {
          path: '/sekar-vote',
          name: 'sekar-vote',
          meta: { preloader: true, floatIcon: true },
          props: true,
          component: () => import('@/landing-page/detail/sekar-vote.vue')
        },
        {
          path: '/sekar-forum',
          name: 'sekar-forum',
          meta: { preloader: true, floatIcon: true },
          props: true,
          component: () => import('@/landing-page/detail/sekar-forum.vue')
        },
        {
          path: '/all-news',
          name: 'all-news',
          meta: { preloader: true, floatIcon: true },
          props: true,
          component: () => import('@/landing-page/semua/all-news.vue')
        },
        {
          path: '/all-gallery',
          name: 'all-gallery',
          meta: { preloader: true, floatIcon: true },
          props: true,
          component: () => import('@/landing-page/semua/all-gallery.vue')
        },
        {
          path: '/all-vote',
          name: 'all-vote',
          meta: { preloader: true, floatIcon: true },
          props: true,
          component: () => import('@/landing-page/semua/all-vote.vue')
        },
        {
          path: '/profile-user',
          name: 'profile-user',
          meta: { preloader: true, floatIcon: false },
          props: true,
          component: () => import('@/default-page/profile-page.vue')
        }
      ]
    },
    // ==========================
    {
      path: '/term-condition',
      name: 'term-condition',
      component: TermPage
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: PrivacyPage
    },
    {
      path: '/authenticate',
      name: 'sso-login-apps',
      component: SSOLoginPage
    },
    {
      path: '/register',
      name: 'register-apps',
      component: _config.options.allowRegister ? RegisterPage : LandingPage
    },
    {
      path: '/verify-email',
      name: 'verify-apps',
      component: _config.options.allowRegister ? VerifyPage : LandingPage
    },
    {
      path: '/waiting-account',
      name: 'waiting-apps',
      component: _config.options.allowRegister ? WaitingPage : LandingPage,
      props: true
    },
    {
      path: '/reset-password',
      name: 'reset-apps',
      component: _config.options.forgetPassword ? ResetPass : LandingPage,
      props: _config.options.forgetPassword ? route => ({ code: route.query.code, ts: Number(route.query.ts) }) : true
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (localStorage.getItem('modules') !== undefined || localStorage.getItem('modules') !== null) {
    let noAuth = ['landing-apps', 'landing-landing', 'kritik-saran', 'organisasi-landing', 'pengaduan-landing', 'pengisian-aduan', 'sekar-news', 'sekar-vote', 'sekar-gallery', 'sso-login-apps', 'privacy-policy', 'term-condition', 'register-apps', 'verify-apps', 'waiting-apps', 'reset-apps']
    if (!noAuth.includes(to.name) && (localStorage.getItem('_token') === undefined || localStorage.getItem('_token') == null)) {
      next({ name: 'landing-landing', replace: true })
    } else {
      if (to.name && from.name) {
        if ((to.name !== from.name) || (to.query.view !== from.query.view)) next()
        else return false
      } else {
        next()
      }
    }
  } else next({ name: 'landing-landing', replace: true })

  if (router.app.$store) {
    router.app.$store.commit('set', ['preloader', true, true])
  }
})

router.afterEach((to, from, failure) => {
  setTimeout(() => {
    if (router.app.$store) {
      router.app.$store.commit('set', ['preloader', false, true])
    }
  }, 1000)
})

export default router



// WEBPACK FOOTER //
// ./src/router.js